const CONFIGURE = {
    state: {
        edition: [],
        logo1:''
    },

    getters: {
        configure(state) {
            return state
        }
    },

    mutations: {
        saveconfigure: (state, v) => {
            state.edition = v.edition
            state.logo1 = v.logo1
        }
    }
};

export { CONFIGURE };



// WEBPACK FOOTER //
// ./src/store/configure.js